import { render } from "./CustomDetailsView.vue?vue&type=template&id=b057c814&ts=true"
import script from "./CustomDetailsView.vue?vue&type=script&lang=ts"
export * from "./CustomDetailsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__